import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import * as customerActions from "../../Redux/Actions/customer";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toastMessage } from "../../utils/toast";
import { clearSession } from "../../utils/initiate";
import Warning from "../Ui/400";

const CustomerManagement = ({ history }) => {
  let itemsPerPage = 10;
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errStatus, setErrStatus] = useState(200);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState({
    email: "",
    mobileNumber: "",
    userType: "",
  });

  useEffect(() => {
    setLoading(true);
    fetchData({});
  }, []);

  const fetchData = (payload) => {
    customerActions
      .getAll(payload)
      .then((res) => {
        if (res && res.data) {
          setData(res.data);
        } else {
          toastMessage(
            "error",
            (res && res.message) || `Unable to load the customers`
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        setErrStatus(err.response.status);
        err.response.status === 401 && clearSession(dispatch, history);
      });
  };

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  if (errStatus === 400) {
    return <Warning history={history} />;
  }

  const filterStateChange = (stateField, value) => {
    setFilterData((preState) => ({
      ...preState,
      [stateField]: value,
    }));
  };
  
  const handleFilter = () => {
    fetchData(filterData);
    setItemOffset(0)
    setPageCount(0)
  };

  const clearFilter = () => {
    setFilterData({
      email: "",
      mobileNumber: "",
      userType: "",
    });
    fetchData({});
    setItemOffset(0)
    setPageCount(0)
  };
  return (
    <>
      <div className="container-fluid">
        <div className="page-title-box">
          <h4 className="page-title my-2">
            {t("customersManagement.manageCustomer.title")}
          </h4>
        </div>
        <div className="row">
          <div className="col-lg-12 col-xxl-12">
            <div className="card card-custom card-stretch gutter-b">
              {loading ? (
                <Loader
                  type="ThreeDots"
                  color="#2d207d"
                  height={40}
                  width={40}
                  style={{ textAlign: "center", marginBottom: "50px" }}
                />
              ) : (
                <div className="card-body p-3">
                  <div className="tab-content">
                    <div className="d-flex align-items-center mb-3">
                      <div className="me-3" style={{ width: "20%" }}>
                        <label className="mb-1 ms-1 me-3">
                          {t("customersManagement.filter.lable.email")}
                        </label>
                        <input
                          placeholder={t(
                            "customersManagement.filter.placeholder.email"
                          )}
                          type="text"
                          className="form-control me-3"
                          value={filterData.email}
                          onChange={(e) => {
                            filterStateChange("email", e.target.value);
                          }}
                        />
                      </div>
                      <div className="me-3" style={{ width: "20%" }}>
                        <label className="mb-1 ms-1 me-3">
                          {t("customersManagement.filter.lable.mobileNumber")}
                        </label>
                        <input
                          placeholder={t(
                            "customersManagement.filter.placeholder.mobileNumber"
                          )}
                          type="number"
                          className="form-control me-3"
                          value={filterData.mobileNumber}
                          onChange={(e) => {
                            filterStateChange("mobileNumber", e.target.value);
                          }}
                        />
                      </div>
                      <div className="me-3" style={{ width: "20%" }}>
                        <label className="mb-1 ms-1 me-3">
                          {t("customersManagement.filter.lable.userType")}
                        </label>
                        <input
                          placeholder={t(
                            "customersManagement.filter.placeholder.userType"
                          )}
                          type="number"
                          className="form-control me-3"
                          value={filterData.userType}
                          onChange={(e) => {
                            filterStateChange("userType", e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex mb-3">
                      <button
                        onClick={handleFilter}
                        type="button"
                        className="d-flex px-5 align-items-center btn btn-primary font-weight-bold"
                      >
                        {t("jobsManagement.filters.filter")}
                      </button>
                      <button
                        onClick={clearFilter}
                        type="button"
                        className="px-5 d-flex align-items-center btn btn-primary font-weight-bold mx-2"
                      >
                        {t("jobsManagement.filters.clearFilters")}
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-head-custom table-vertical-center table-head-bg">
                        <thead>
                          <tr className="text-left">
                            <th style={{ minWidth: "100px" }} className="pl-7">
                              <span className="text-dark-75">
                                {t("customersManagement.manageCustomer.sNo")}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t("customersManagement.manageCustomer.id")}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t(
                                  "customersManagement.manageCustomer.tableTitle"
                                )}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t(
                                  "customersManagement.manageCustomer.firstName"
                                )}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t(
                                  "customersManagement.manageCustomer.lastName"
                                )}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t(
                                  "customersManagement.manageCustomer.fullName"
                                )}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t("customersManagement.manageCustomer.email")}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t(
                                  "customersManagement.manageCustomer.mobileNumber"
                                )}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t(
                                  "customersManagement.manageCustomer.userType"
                                )}
                              </span>
                            </th>
                            <th style={{ minWidth: "100px" }}>
                              <span className="text-dark-75">
                                {t("customersManagement.manageCustomer.action")}
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map(
                              (
                                {
                                  id,
                                  title,
                                  firstName,
                                  lastName,
                                  fullName,
                                  email,
                                  mobileNumber,
                                  userType,
                                },
                                index
                              ) => (
                                <tr key={index}>
                                  <td className="pl-7">
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {index + 1}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {id}
                                    </span>
                                  </td>
                                  <td className="pl-0 py-8">
                                    <span className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg">
                                      {title}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {firstName}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {lastName}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {fullName}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {email}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {mobileNumber}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {userType}
                                    </span>
                                  </td>
                                  <td className="pr-0">
                                    <p
                                      onClick={() =>
                                        history.push(
                                          `/customer/info?id=${id}`
                                        )
                                      }
                                      className="btn btn-warning font-weight-bolder font-size-sm me-2"
                                    >
                                      {t(
                                        "customersManagement.manageCustomer.more"
                                      )}
                                    </p>
                                    {/* <p onClick={() => history.push(`/customer/update?id=${id}`)} className="btn btn-info font-weight-bolder font-size-sm">{t("customersManagement.manageCustomer.update")}</p> */}
                                  </td>
                                </tr>
                              )
                            )}
                        </tbody>
                      </table>
                      {pageCount > 1 && (
                        <ReactPaginate
                          breakLabel="..."
                          nextLabel=">"
                          previousLabel="<"
                          onPageChange={handlePageClick}
                          pageRangeDisplayed={5}
                          pageCount={pageCount}
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          containerClassName="pagination"
                          activeClassName="active"
                          renderOnZeroPageCount={null}
                        />
                      )}
                      {data.length === 0 && (
                        <p className="text-center mt-5 mb-5">
                          {t("customersManagement.noDataAvailable")}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerManagement;
